<style>
  .filter-expand-style {
    letter-spacing: normal; 
    text-transform: none;
  }

  .bigger-text > .v-input__control > .v-input__slot {
      border-bottom: 2px solid black;
  }

  .bigger-text > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
      font-size: 16px !important;
      max-height: 40px !important;
      height: 20px;
  }
  .bigger-text > .v-input__control > .v-input__slot > .v-text-field__slot > input {
      font-size: 20px !important;
      max-height: 40px !important;
  }

  .data-table-row-unactive {
    background-color: #eeeeee;
  }

  .v-pagination__navigation {
    display: none !important;
  }

  .paginate_button-prev-icon {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyLjAxNCAzLjA5NGwxLjExIDEuMTExLTcuMDIyIDcuMDIyIDE0Ljc5OS0uMDMuMDAzIDEuNTctMTQuODEuMDMyIDYuOTk1IDYuOTk2LTEuMTEgMS4xMS04LjMzMS04LjMzMi0uNTUyLS41NTUuMDAzLS4wMDIuNTQ5LS41NTQgOC4zNjYtOC4zNjh6IiBmaWxsPSIjMDAwIi8+PC9zdmc+);
    margin-left: 8px;
    width: 32px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 32px;
    flex: 0 0 32px;
    content: "";
    background-size: contain;
    height: 32px;
    box-sizing: border-box;
  }

  .paginate_button-next-icon {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjk4NiAzLjA5NGwtMS4xMSAxLjExMSA3LjAyMiA3LjAyMi0xNC43OTgtLjAzLS4wMDQgMS41NyAxNC44MS4wMzItNi45OTUgNi45OTYgMS4xMSAxLjExIDguMzMxLTguMzMyLjU1Mi0uNTU1LS4wMDMtLjAwMi0uNTQ5LS41NTQtOC4zNjYtOC4zNjh6IiBmaWxsPSIjMDAwIi8+PC9zdmc+);
    margin-left: 8px;
    width: 32px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 32px;
    flex: 0 0 32px;
    content: "";
    background-size: contain;
    height: 32px;
    box-sizing: border-box;
  }

  .v-pagination__item {
    box-shadow: none !important;
  }

  .v-pagination > li > .v-pagination__item--active {
    background-color: transparent !important;
    border: 2px black solid !important;
    color: black !important;
    transition: none !important;
  }

  .paginate_button-text {
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }

  .paginate_button-text:hover {
    text-decoration: underline;
  }
</style>

<template>
  <span>
    <v-card elevation="0" v-if="show_tables" class="mb-10">
      <v-container style="max-width: 1680px;" class="pa-0">
        <div v-show="show_tables_org">
          <CatalogList
            object_type="organization"
            header_text="Організації"
            :breadcrumbs_items="[{
                text: 'Каталог',
                disabled: false,
                href: '/',
            }, {
                text: $route.query.env == 'SEVDEIR' ? 'Організації (пром)' : 'Організації (тест)',
                disabled: false,
                href: '/catalog/organizations?env=' + $route.query.env,
            },]"
            :list_headers="main_organization_list_headers"
            :list_items="main_organization_list"
            :list_loading="main_organization_list_loading"
            :list_size="main_organization_list_size"
            :list_search_fields="main_organization_list_search_fields"
            :list_items_per_page.sync="main_organization_list_items_per_page"
            :current_page.sync="current_organization_page"

            @clearFilters="clearFilters"
            @updateFilters="updateFilters"
            @updateHeaders="updateHeaders"
            @exportToExcel="exportToExcel"
            @exportToCSV="exportToCSV"
            @requestList="requestOrganizationsList"
            @onClickDetailSelect="onClickOrganizationDetailSelect"
          />
        </div>

        <div v-show="show_tables_irs">
          <CatalogList
            object_type="information_resource"
            header_text="Е-ресурси"
            :breadcrumbs_items="[{
                text: 'Каталог',
                disabled: false,
                href: '/',
            }, {
                text: $route.query.env == 'SEVDEIR' ? 'Е-ресурси (пром)' : 'Е-ресурси (тест)',
                disabled: false,
                href: '/catalog/information_resources?env=' + $route.query.env,
            },]"
            :list_headers="main_information_resource_list_headers"
            :list_items="main_information_resource_list"
            :list_loading="main_information_resource_list_loading"
            :list_size="main_information_resource_list_size"
            :list_search_fields="main_information_resource_list_search_fields"
            :list_items_per_page.sync="main_information_resource_list_items_per_page"
            :current_page.sync="current_information_resource_page"

            @clearFilters="clearFilters"
            @updateFilters="updateFilters"
            @updateHeaders="updateHeaders"
            @requestList="requestInformationResourcesList"
            @onClickDetailSelect="onClickInformationResourceDetailSelect"
          />
        </div>

        <div v-show="show_tables_sub">
          <CatalogList
            object_type="subsystem"
            header_text="Підсистеми"
            :breadcrumbs_items="[{
                text: 'Каталог',
                disabled: false,
                href: '/',
            }, {
                text: $route.query.env == 'SEVDEIR' ? 'Підсистеми (пром)' : 'Підсистеми (тест)',
                disabled: false,
                href: '/catalog/subsystems?env=' + $route.query.env,
            },]"
            :list_headers="main_subsystem_list_headers"
            :list_items="main_subsystem_list"
            :list_loading="main_subsystem_list_loading"
            :list_size="main_subsystem_list_size"
            :list_search_fields="main_subsystem_list_search_fields"
            :list_items_per_page.sync="main_subsystem_list_items_per_page"
            :current_page.sync="current_subsystem_page"

            @clearFilters="clearFilters"
            @updateFilters="updateFilters"
            @updateHeaders="updateHeaders"
            @requestList="requestSubsystemsList"
            @onClickDetailSelect="onClickSubsystemDetailSelect"
          />
        </div>

        <div v-show="show_tables_intf">
          <CatalogList
            object_type="interface"
            header_text="Інтерфейси е-ресурсів"
            :breadcrumbs_items="[{
                text: 'Каталог',
                disabled: false,
                href: '/',
            }, {
                text: $route.query.env == 'SEVDEIR' ? 'Інтерфейси е-ресурсів (пром)' : 'Інтерфейси е-ресурсів (тест)',
                disabled: false,
                href: '/catalog/interfaces?env=' + $route.query.env,
            },]"
            :list_headers="main_interface_list_headers"
            :list_items="main_interface_list"
            :list_loading="main_interface_list_loading"
            :list_size="main_interface_list_size"
            :list_search_fields="main_interface_list_search_fields"
            :list_items_per_page.sync="main_interface_list_items_per_page"
            :current_page.sync="current_interface_page"

            @clearFilters="clearFilters"
            @updateFilters="updateFilters"
            @updateHeaders="updateHeaders"
            @requestList="requestInterfaceList"
            @onClickDetailSelect="onClickInterfaceDetailSelect"
          />
        </div>

        <div v-show="show_tables_srv">
          <CatalogList
            object_type="service"
            header_text="Сервіси"
            :breadcrumbs_items="[{
                text: 'Каталог',
                disabled: false,
                href: '/',
            }, {
                text: $route.query.env == 'SEVDEIR' ? 'Сервіси (пром)' : 'Сервіси (тест)',
                disabled: false,
                href: '/catalog/services?env=' + $route.query.env,
            },]"
            :list_headers="main_service_list_headers"
            :list_items="main_service_list"
            :list_loading="main_service_list_loading"
            :list_size="main_service_list_size"
            :list_search_fields="main_service_list_search_fields"
            :list_items_per_page.sync="main_service_list_items_per_page"
            :current_page.sync="current_service_page"

            @clearFilters="clearFilters"
            @updateFilters="updateFilters"
            @updateHeaders="updateHeaders"
            @requestList="requestServiceList"
            @onClickDetailSelect="onClickServiceDetailSelect"
          />
        </div>

        <div v-show="show_tables_itr">
          <CatalogList
            object_type="interaction"
            header_text="Взаємодії"
            :breadcrumbs_items="[{
                text: 'Каталог',
                disabled: false,
                href: '/',
            }, {
                text: $route.query.env == 'SEVDEIR' ? 'Взаємодії (пром)' : 'Взаємодії (тест)',
                disabled: false,
                href: '/catalog/interactions?env=' + $route.query.env,
            },]"
            :list_headers="main_interaction_list_headers"
            :list_items="main_interaction_list"
            :list_loading="main_interaction_list_loading"
            :list_size="main_interaction_list_size"
            :list_search_fields="main_interaction_list_search_fields"
            :list_items_per_page.sync="main_interaction_list_items_per_page"
            :current_page.sync="current_interaction_page"

            @clearFilters="clearFilters"
            @updateFilters="updateFilters"
            @updateHeaders="updateHeaders"
            @requestList="requestInteractionList"
            @onClickDetailSelect="onClickInteractionDetailSelect"
          />
        </div>

        <div v-show="show_tables_ss">
          <CatalogList
            object_type="server"
            header_text="Шлюзи безпечного обміну"
            :breadcrumbs_items="[{
                text: 'Каталог',
                disabled: false,
                href: '/',
            }, {
                text: $route.query.env == 'SEVDEIR' ? 'Шлюзи безпечного обміну (пром)' : 'Шлюзи безпечного обміну (тест)',
                disabled: false,
                href: '/catalog/servers?env=' + $route.query.env,
            },]"
            :list_headers="main_server_list_headers"
            :list_items="main_server_list"
            :list_loading="main_server_list_loading"
            :list_size="main_server_list_size"
            :list_search_fields="main_server_list_search_fields"
            :list_items_per_page.sync="main_server_list_items_per_page"
            :current_page.sync="current_server_page"
            :no-data-text="authData ? 'Дані відсутні' : 'Необхідна авторизація'"

            @clearFilters="clearFilters"
            @updateFilters="updateFilters"
            @updateHeaders="updateHeaders"
            @requestList="requestServerList"
            @onClickDetailSelect="onClickServerDetailSelect"
          />
        </div>
      </v-container>
    </v-card>
  </span>
</template>

<script>
import { mapState } from 'vuex';

/* eslint-disable */
import CatalogList from "./CatalogList";
import axios from "axios";
import clib from "../js/common_lib";
import * as XLSX from 'xlsx';

export default {
  name: "CatalogListPageApi",
  components: {
      CatalogList
  },
  data: () => ({
    main_organization_list_loading: false,
    main_information_resource_list_loading: false,
    main_subsystem_list_loading: false,
    main_interface_list_loading: false,
    main_service_list_loading: false,
    main_interaction_list_loading: false,
    main_server_list_loading: false,

    show_tables: true,
    show_tables_org: true,
    show_tables_irs: false,
    show_tables_sub: false,
    show_tables_intf: false,
    show_tables_srv: false,
    show_tables_itr: false,
    show_tables_ss: false,

    main_org_search: "",
    main_irs_search: "",
    main_sub_search: "",
    main_intf_search: "",
    main_srv_search: "",
    main_itr_search: "",
    main_ss_search: "",

    current_organization_page: 1,
    current_information_resource_page: 1,
    current_subsystem_page: 1,
    current_interface_page: 1,
    current_service_page: 1,
    current_interaction_page: 1,
    current_server_page: 1,

    items: [
        { title: 'Загальний опис', icon: 'mdi-earth', ref: 'detail_info' },
        { title: 'Статистика', icon: 'mdi-domain', ref: 'detail_stats' },
        { title: 'Інформаційні е-ресурси', icon: 'mdi-domain', ref: 'detail_irs' },
        { title: 'Підсистеми', icon: 'mdi-domain', ref: 'detail_sub' },
        { title: 'Інтерфейси е-ресурсів', icon: 'mdi-domain', ref: 'detail_intf' },
        { title: 'Сервіси', icon: 'mdi-laptop', ref: 'detail_srv' },
      ],

    main_organization_list_headers: [],
    main_information_resource_list_headers: [],
    main_subsystem_list_headers: [],
    main_interface_list_headers: [],
    main_service_list_headers: [],
    main_interaction_list_headers: [],
    main_server_list_headers: [],

    main_organization_list_data: [],
    main_information_resource_list_data: [],
    main_subsystem_list_data: [],
    main_interface_list_data: [],
    main_service_list_data: [],
    main_interaction_list_data: [],
    main_server_list_data: [],

    filterOrganizationKey: 1003000,
    filterInformationResourceKey: 1004000,
    filterSubsystemKey: 1005000,
    filterInterfaceKey: 1006000,
    filterServiceKey: 1007000,
    filterInteractionKey: 1008000,
    filterServerKey: 1009000,

    main_organization_list_size: 0,
    main_organization_list_items_per_page: 10,
    main_organization_list_search_fields: {},

    main_information_resource_list_size: 0,
    main_information_resource_list_items_per_page: 10,
    main_information_resource_list_search_fields: {},

    main_subsystem_list_size: 0,
    main_subsystem_list_items_per_page: 10,
    main_subsystem_list_search_fields: {},

    main_interface_list_size: 0,
    main_interface_list_items_per_page: 10,
    main_interface_list_search_fields: {},

    main_service_list_size: 0,
    main_service_list_items_per_page: 10,
    main_service_list_search_fields: {},

    main_interaction_list_size: 0,
    main_interaction_list_items_per_page: 10,
    main_interaction_list_search_fields: {},

    main_server_list_size: 0,
    main_server_list_items_per_page: 10,
    main_server_list_search_fields: {},
  }),
  computed: {
    ...mapState(['authData', 'freshTokenRetrievalTransactionCompleted']),

    main_organization_list: function() {
      return clib.imprecizeComparison(this.main_org_search, this.main_organization_list_data);
    },
    main_information_resource_list: function() {
      return clib.imprecizeComparison(this.main_irs_search, this.main_information_resource_list_data);
    },
    main_subsystem_list: function() {
      return clib.imprecizeComparison(this.main_sub_search, this.main_subsystem_list_data);
    },
    main_interface_list: function() {
      return clib.imprecizeComparison(this.main_intf_search, this.main_interface_list_data);
    },
    main_service_list: function() {
    //   return clib.imprecizeComparison(this.main_srv_search, this.main_service_list_data);
        return this.main_service_list_data;
    },
    main_interaction_list: function() {
      return clib.imprecizeComparison(this.main_itr_search, this.main_interaction_list_data);
    },

    main_server_list: function() {
      return clib.imprecizeComparison(this.main_ss_search, this.main_server_list_data);
    },

    // main_service_page_count: function() {
    //   if (this.main_service_list_size && this.main_service_list_items_per_page) {
    //     return Math.ceil(this.main_service_list_size / this.main_service_list_items_per_page);
    //   }
    // }
  },

  created: function () {
    document.title = 'Каталог вебсервісів';
    document.activeElement.blur();

    // Here make some default parsings of given url
    this.setRouterQueryParams();

    // this.main_organization_list_headers = this.$config.configuration.organization.list.items;

    // this.main_organization_list_headers = this.$config.configuration.organization.list.items.filter(item => localStorage.getItem('organization_list_headers').split(',').includes(item.value));
    // this.main_information_resource_list_headers = this.$config.configuration.information_resource.list.items;
    // this.main_subsystem_list_headers = this.$config.configuration.subsystem.list.items;
    // this.main_interface_list_headers = this.$config.configuration.information_resource_interface.list.items;
    // this.main_service_list_headers = this.$config.configuration.service.list.items;
    // this.main_interaction_list_headers = this.$config.configuration.interaction.list.items;
    // this.main_server_list_headers = this.$config.configuration.server.list.items;

    this.updateHeaders();

    this.setListRouterToDisplay(this.$route.name);
    this.requestAllTables();
  },

  watch: {
    // authData() {
    //   this.requestServerList();
    // },
    freshTokenRetrievalTransactionCompleted() {
      if (this.authData) {
        this.requestServerList();
      }
    },
    $route(to, from) {
        this.setListRouterToDisplay(to.name);
        this.setRouterQueryParams(to, from);

        if (to.name != from.name)
          this.updateRouterFilterParams(to, from);

        document.title = to.meta.title || '';
    },
  },

  methods: {

    informationResourceItemListRowClass(item) {
      return !item.display_active ? 'data-table-row-unactive' : '';
    },
    informationResourceInterfacesItemListRowClass(item) {
      return !item.display_active ? 'data-table-row-unactive' : '';
    },
    interactionItemListRowClass(item) {
      return !item.display_active ? 'data-table-row-unactive' : '';
    },

    keydownSearch(key) {
        if (key.keyCode == 13) {
            this.requestServiceList();
        }
    },


    updateFilters(object_type) {

      if (object_type == 'organization') {
        this.$router.replace({name: 'organizations-list', query: clib.getFiltersQuery(this.$config, object_type)});
        this.requestOrganizationsList();
      } 
      else if (object_type == 'information_resource') {
        this.$router.replace({name: 'information-resources-list', query: clib.getFiltersQuery(this.$config, object_type)});
        this.requestInformationResourcesList();
      }
      else if (object_type == 'subsystem') {
        this.$router.replace({name: 'subsystems-list', query: clib.getFiltersQuery(this.$config, object_type)});
        this.requestSubsystemsList();
      }
      else if (object_type == 'interface') {
        this.$router.replace({name: 'interfaces-list', query: clib.getFiltersQuery(this.$config, object_type)});
        this.requestInterfaceList();
      }
      else if (object_type == 'service') {
        this.$router.replace({name: 'services-list', query: clib.getFiltersQuery(this.$config, object_type)});
        this.requestServiceList();
      }
      else if (object_type == 'interaction') {
        this.$router.replace({name: 'interactions-list', query: clib.getFiltersQuery(this.$config, object_type)});
        this.requestInteractionList();
      }
      else if (object_type == 'server') {
        this.$router.replace({name: 'servers-list', query: clib.getFiltersQuery(this.$config, object_type)});
        this.requestServerList();
      }
    },
    sortByOrder(data, orderString) {
        const dataValues = new Set(data.map(item => item.value));

        const orderArray = orderString.split(',').filter(value => dataValues.has(value));
        const orderMap = {};

        orderArray.forEach((value, index) => {
            orderMap[value] = index;
        });

        return data.sort((a, b) => {
            return orderMap[a.value] - orderMap[b.value];
        });
    },
    updateHeaders() {
      // if (object_type == 'organization') {
        this.main_organization_list_headers = this.sortByOrder(this.$config.configuration.organization.list.items.filter(item => localStorage.getItem('organization_list_headers').split(',').includes(item.value)), localStorage.getItem('organization_list_order'));
        this.main_information_resource_list_headers = this.sortByOrder(this.$config.configuration.information_resource.list.items.filter(item => localStorage.getItem('eresource_list_headers').split(',').includes(item.value)), localStorage.getItem('eresource_list_order'));
        this.main_subsystem_list_headers = this.sortByOrder(this.$config.configuration.subsystem.list.items.filter(item => localStorage.getItem('subsystem_list_headers').split(',').includes(item.value)), localStorage.getItem('subsystem_list_order'));
        this.main_interface_list_headers = this.sortByOrder(this.$config.configuration.information_resource_interface.list.items.filter(item => localStorage.getItem('interface_list_headers').split(',').includes(item.value)), localStorage.getItem('interface_list_order'));
        this.main_service_list_headers = this.sortByOrder(this.$config.configuration.service.list.items.filter(item => localStorage.getItem('service_list_headers').split(',').includes(item.value)), localStorage.getItem('service_list_order'));
        this.main_interaction_list_headers = this.sortByOrder(this.$config.configuration.interaction.list.items.filter(item => localStorage.getItem('interaction_list_headers').split(',').includes(item.value)), localStorage.getItem('interaction_list_order'));
        this.main_server_list_headers = this.sortByOrder(this.$config.configuration.server.list.items.filter(item => localStorage.getItem('server_list_headers').split(',').includes(item.value)), localStorage.getItem('server_list_order'));
      // } 
      // else if (object_type == 'information_resource') {

      // }
      // else if (object_type == 'subsystem') {

      // }
      // else if (object_type == 'interface') {

      // }
      // else if (object_type == 'service') {

      // }
      // else if (object_type == 'interaction') {

      // }
      // else if (object_type == 'server') {

      // }
    },
    clearFilters(object_type) {
      this.$config.filter_params[object_type] = {};

      if (object_type == 'organization') {
        this.$router.replace({name: 'organizations-list', query: {...this.$config.query_params}});
        this.filterOrganizationKey = clib.uuidv4();
        this.requestOrganizationsList();
      }
      else if (object_type == 'information_resource') {
        this.$router.replace({name: 'information-resources-list', query: this.$config.query_params});
        this.filterInformationResourceKey = clib.uuidv4();
        this.requestInformationResourcesList();
      }
      else if (object_type == 'subsystem') {
        this.$router.replace({name: 'subsystems-list', query: this.$config.query_params});
        this.filterSubsystemKey = clib.uuidv4();
        this.requestSubsystemsList();
      }
      else if (object_type == 'interface') {
        this.$router.replace({name: 'interfaces-list', query: this.$config.query_params});
        this.filterInterfaceKey = clib.uuidv4();
        this.requestInterfaceList();
      }
      else if (object_type == 'service') {
        this.$router.replace({name: 'services-list', query: this.$config.query_params});
        this.filterServiceKey = clib.uuidv4();
        this.requestServiceList();
      }
      else if (object_type == 'interaction') {
        this.$router.replace({name: 'interactions-list', query: this.$config.query_params});
        this.filterInteractionKey = clib.uuidv4();
        this.requestInteractionList();
      }
      else if (object_type == 'server') {
        this.$router.replace({name: 'servers-list', query: this.$config.query_params});
        this.filterServerKey = clib.uuidv4();
        this.requestServerList();
      }
    },
    updateRouterFilterParams(to, from) {
      if (to.name == 'organizations-list' && this.$config.filter_params['organization'])
          this.$router.replace({name: 'organizations-list', query: clib.getFiltersQuery(this.$config, 'organization')});
      else if (to.name == 'information-resources-list' && this.$config.filter_params['information_resource'])
          this.$router.replace({name: 'information-resources-list', query: clib.getFiltersQuery(this.$config, 'information_resource')});
      else if (to.name == 'subsystems-list' && this.$config.filter_params['subsystem'])
          this.$router.replace({name: 'subsystems-list', query: clib.getFiltersQuery(this.$config, 'subsystem')});
      else if (to.name == 'interfaces-list' && this.$config.filter_params['interface'])
          this.$router.replace({name: 'interfaces-list', query: clib.getFiltersQuery(this.$config, 'interface')});
      else if (to.name == 'services-list' && this.$config.filter_params['service'])
          this.$router.replace({name: 'services-list', query: clib.getFiltersQuery(this.$config, 'service')});
      else if (to.name == 'interactions-list' && this.$config.filter_params['interaction'])
          this.$router.replace({name: 'interactions-list', query: clib.getFiltersQuery(this.$config, 'interaction')});
    },
    setRouterQueryParams(to, from) {
        if ('search_org' in this.$route.query)
            this.main_org_search = this.$route.query.search_org;
        if ('search_irs' in this.$route.query)
            this.main_irs_search = this.$route.query.search_irs;
        if ('search_sub' in this.$route.query)
            this.main_sub_search = this.$route.query.search_sub;
        if ('search_intf' in this.$route.query)
            this.main_intf_search = this.$route.query.search_intf;
        if ('search_srv' in this.$route.query)
            this.main_srv_search = this.$route.query.search_srv;

        if ('search' in this.$route.query) {
            this.main_org_search = this.$route.query.search;
            this.main_irs_search = this.$route.query.search;
            this.main_sub_search = this.$route.query.search;
            this.main_intf_search = this.$route.query.search;
            this.main_srv_search = this.$route.query.search;
        }
    },

    setListRouterToDisplay(value) {
      this.show_tables_org = false;
      this.show_tables_irs = false;
      this.show_tables_sub = false;
      this.show_tables_intf = false;
      this.show_tables_srv = false;
      this.show_tables_itr = false;
      this.show_tables_ss = false;

      if (value == 'organizations-list')
        this.show_tables_org = true;
      else if (value == 'information-resources-list')
        this.show_tables_irs = true;
      else if (value == 'subsystems-list')
        this.show_tables_sub = true;
      else if (value == 'interfaces-list')
        this.show_tables_intf = true;
      else if (value == 'services-list')
        this.show_tables_srv = true;
      else if (value == 'interactions-list')
        this.show_tables_itr = true;
      else if (value == 'servers-list')
        this.show_tables_ss = true;
    },

    requestAllTables() {
      this.requestOrganizationsList();
      this.requestInformationResourcesList();
      this.requestSubsystemsList();
      this.requestInterfaceList();
      this.requestServiceList();
      this.requestInteractionList();

      if (this.authData && this.freshTokenRetrievalTransactionCompleted) {
        this.requestServerList();
      }
    },


    onClickOrganizationDetailSelect(val) {
      this.$router.push({name: 'organization-detail-info', params: {'id': val.id}, query: {'env': this.$config.query_params.env}});
    },
    onClickInformationResourceDetailSelect(val) {
      this.$router.push({name: 'information-resource-detail-info', params: {'id': val.id}, query: {'env': this.$config.query_params.env}});
    },
    onClickSubsystemDetailSelect(val) {
      this.$router.push({name: 'subsystem-detail-info', params: {'id': val.id}, query: {'env': this.$config.query_params.env}});
    },
    onClickInterfaceDetailSelect(val) {
      this.$router.push({name: 'interface-detail-info', params: {'id': val.id}, query: {'env': this.$config.query_params.env}});
    },
    onClickServiceDetailSelect(val) {
      this.$router.push({name: 'service-detail-info', params: {'id': val.id}, query: {'env': this.$config.query_params.env}});
    },
    onClickInteractionDetailSelect(val) {
      this.$router.push({name: 'interaction-detail-info', params: {'id': val.id}, query: {'env': this.$config.query_params.env}});
    },
    onClickServerDetailSelect(val) {
      this.$router.push({name: 'server-detail-info', params: {'id': val.id}, query: {'env': this.$config.query_params.env}});
    },


    saveBook(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xff;
        }
        return buf;
    },

    exportToCSV() {

    },

    exportToExcel() {
        var ns = XLSX.utils.book_new();
        ns.props = {
            title: "new excell sheet",
            subject: "test",
            Ather: "Shan",
            createdDate: Date.now(),
        };
        ns.SheetNames.push("Test");
        
        console.log("MUHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
        console.log(this.list_data);

        let new_headers_selected = Object.keys(this.selected_headers).filter(key => this.selected_headers[key]);

        let curr_headers = this.available_headers_list.filter(item => localStorage.getItem(this.object_headers_localstorage_name).split(',').includes(item.value)).map(item => item.text);
        console.log(curr_headers);


        let excel_data = this.list_data.map(item => {
            return new_headers_selected.map(key => item[key]);
        });

        var nb_data = [curr_headers].concat(excel_data);

        var nb = XLSX.utils.aoa_to_sheet(nb_data);
        ns.Sheets["Test"] = nb;

        var nbOut = XLSX.write(ns, { bookType: "xlsx", type: "binary" });
        
        let blob = new Blob([this.saveBook(nbOut)], { type: "application/octet-stream" });

        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "file.xlsx");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

    },



    requestOrganizationsList() {
      this.main_organization_list_loading = true;
      const query_params = new URLSearchParams(clib.getFiltersQuery(this.$config, 'organization')).toString();

      let request_url = "";
      if (this.current_organization_page && this.main_organization_list_items_per_page)
        request_url = this.$config.configuration.organization.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + "?page=" + this.current_organization_page + "&page_size=" + this.main_organization_list_items_per_page + "&" + query_params;
      else
        request_url = this.$config.configuration.organization.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + query_params;

      for (let search_item in this.main_organization_list_search_fields) {
        if (this.main_organization_list_search_fields[search_item]) {
          request_url += "&search_" + search_item + "=" + this.main_organization_list_search_fields[search_item];
        }
      }

      axios({
          method: "get",
          url: request_url,
          params: {
            instance: this.$config.query_params.env
          }
      })
      .then((response) => {
          this.main_organization_list_data = [];
          for (let item in response.data.items) {
              let ukr_date = this.$clib.dateFormatToUkrainian(response.data.items[item].register_statement__registration_date || response.data.items[item].connection_agreement_date);

              this.main_organization_list_data.push({
                  "id": response.data.items[item].id,
                  "name": response.data.items[item].name,
                  "member_code": response.data.items[item].member_code,
                  "date": ukr_date,
                  "class": 'data-table-header'
              })
          }

          this.main_organization_list_size = response.data.count;
      })
      .catch((error) => {})
      .finally(() => {
          this.main_organization_list_loading = false;
      });
    },

    requestInformationResourcesList() {
      this.main_information_resource_list_loading = true;
      const query_params = new URLSearchParams(clib.getFiltersQuery(this.$config, 'information_resource')).toString();

      let request_url = "";
      if (this.current_information_resource_page && this.main_information_resource_list_items_per_page)
        request_url = this.$config.configuration.information_resource.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + "?page=" + this.current_information_resource_page + "&page_size=" + this.main_information_resource_list_items_per_page + "&" + query_params;
      else
        request_url = this.$config.configuration.information_resource.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + query_params;

      for (let search_item in this.main_information_resource_list_search_fields) {
        if (this.main_information_resource_list_search_fields[search_item]) {
          request_url += "&search_" + search_item + "=" + this.main_information_resource_list_search_fields[search_item];
        }
      }

      axios({
          method: "get",
          url: request_url,
          params: {
            instance: this.$config.query_params.env
          }
      })
      .then((response) => {
          this.main_information_resource_list_data = [];
          for (let item in response.data.items) {
              this.main_information_resource_list_data.push({
                  "id": response.data.items[item].id,
                  "name": response.data.items[item].name,
                  "owner__name": response.data.items[item].owner__name,
                  "owner__member_code": response.data.items[item].owner__member_code,
                  "display_active": response.data.items[item].display_active,
                  "class": 'data-table-header'
              })
          }
          this.main_information_resource_list_size = response.data.count;
      })
      .catch((error) => {})
      .finally(() => {
          this.main_information_resource_list_loading = false;
      });
    },


    requestSubsystemsList() {
      this.main_subsystem_list_loading = true;
      const query_params = new URLSearchParams(clib.getFiltersQuery(this.$config, 'subsystem')).toString();

      let request_url = "";
      if (this.current_subsystem_page && this.main_subsystem_list_items_per_page)
        request_url = this.$config.configuration.subsystem.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + "?page=" + this.current_subsystem_page + "&page_size=" + this.main_subsystem_list_items_per_page + "&" + query_params;
      else
        request_url = this.$config.configuration.subsystem.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + query_params;

      for (let search_item in this.main_subsystem_list_search_fields) {
        if (this.main_subsystem_list_search_fields[search_item]) {
          request_url += "&search_" + search_item + "=" + this.main_subsystem_list_search_fields[search_item];
        }
      }

      axios({
          method: "get",
          url: request_url,
          params: {
            instance: this.$config.query_params.env
          }
      })
      .then((response) => {
          this.main_subsystem_list_data = [];
          for (let item in response.data.items) {
              this.main_subsystem_list_data.push({
                  "id": response.data.items[item].id,
                  "subsystem_code": response.data.items[item].subsystem_code,
                  "information_eresource__name": response.data.items[item].information_eresource__name,
                  "owner__name": response.data.items[item].owner__name,
                  "owner__member_code": response.data.items[item].owner__member_code,
                  "is_deleted": response.data.items[item].is_deleted ? 'В архіві' : 'Активний(-на)',
                  "class": 'data-table-header'
              })
          }
          this.main_subsystem_list_size = response.data.count;
      })
      .catch((error) => {})
      .finally(() => {
          this.main_subsystem_list_loading = false;
      });
    },

    requestInterfaceList() {
      this.main_interface_list_loading = true;
      const query_params = new URLSearchParams(clib.getFiltersQuery(this.$config, 'interface')).toString();

      let request_url = "";
      if (this.current_interface_page && this.main_interface_list_items_per_page)
        request_url = this.$config.configuration.information_resource_interface.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + "?page=" + this.current_interface_page + "&page_size=" + this.main_interface_list_items_per_page + "&" + query_params;
      else
        request_url = this.$config.configuration.information_resource_interface.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + query_params;

      for (let search_item in this.main_interface_list_search_fields) {
        if (this.main_interface_list_search_fields[search_item]) {
          request_url += "&search_" + search_item + "=" + this.main_interface_list_search_fields[search_item];
        }
      }

      axios({
          method: "get",
          url: request_url,
          params: {
            instance: this.$config.query_params.env
          }
      })
      .then((response) => {
          this.main_interface_list_data = [];
          for (let item in response.data.items) {
              this.main_interface_list_data.push({
                  "id": response.data.items[item].id,
                  "name": response.data.items[item].name,
                  "registered_at": this.$clib.dateFormatToUkrainian(response.data.items[item].registered_at),
                  "information_eresource__name": response.data.items[item].information_eresource__name,
                  "owner__name": response.data.items[item].owner__name,
                  "owner__member_code": response.data.items[item].owner__member_code,
                  "display_active": response.data.items[item].display_active,
                  "class": 'data-table-header'
              })
          }
          this.main_interface_list_size = response.data.count;
      })
      .catch((error) => {})
      .finally(() => {
          this.main_interface_list_loading = false;
      });
    },

    requestServiceList() {
      // const { sortBy, sortDesc, page, itemsPerPage } = this.main_service_list_options;

      this.main_service_list_loading = true;
      const query_params = new URLSearchParams(clib.getFiltersQuery(this.$config, 'service')).toString();

      let request_url = "";
      if (this.current_service_page && this.main_service_list_items_per_page)
        request_url = this.$config.configuration.service.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + "?page=" + this.current_service_page + "&page_size=" + this.main_service_list_items_per_page + "&" + query_params;
      else
        request_url = this.$config.configuration.service.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + query_params;

      for (let search_item in this.main_service_list_search_fields) {
        if (this.main_service_list_search_fields[search_item]) {
          request_url += "&search_" + search_item + "=" + this.main_service_list_search_fields[search_item];
        }
      }

      axios({
          method: "get",
          url: request_url,
          params: {
            instance: this.$config.query_params.env
          }
      })
      .then((response) => {
          this.main_service_list_data = [];
          for (let item in response.data.items) {
              this.main_service_list_data.push({
                  "id": response.data.items[item].id,
                  "name": response.data.items[item].name,
                  "subsystem__information_eresource__name": response.data.items[item].subsystem__information_eresource__name,
                  "service_code": response.data.items[item].service_code,
                  "subsystem__subsystem_code": response.data.items[item].subsystem__subsystem_code,
                  "interfaces_name": response.data.items[item].main_service_prod_interface_names || 
                                      response.data.items[item].main_service_test_interface_names || 
                                      response.data.items[item].sub_service_prod_interfaces_names || 
                                      response.data.items[item].sub_service_test_interfaces_names,
                  "organization__name": response.data.items[item].organization__name,
                  "organization__member_code": response.data.items[item].organization__member_code,
                  "is_deleted": response.data.items[item].is_deleted ? 'В архіві' : 'Активний(-на)',
                  "class": 'data-table-header'
              })
          }

          this.main_service_list_size = response.data.count;
      })
      .catch((error) => {})
      .finally(() => {
          this.main_service_list_loading = false;
      });
    },

    requestInteractionList() {
      this.main_interaction_list_loading = true;
      const query_params = new URLSearchParams(clib.getFiltersQuery(this.$config, 'interaction')).toString();

      let request_url = "";
      if (this.current_interaction_page && this.main_interaction_list_items_per_page)
        request_url = this.$config.configuration.interaction.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + "?page=" + this.current_interaction_page + "&page_size=" + this.main_interaction_list_items_per_page + "&" + query_params;
      else
        request_url = this.$config.configuration.interaction.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + query_params;

      for (let search_item in this.main_interaction_list_search_fields) {
        if (this.main_interaction_list_search_fields[search_item]) {
          request_url += "&search_" + search_item + "=" + this.main_interaction_list_search_fields[search_item];
        }
      }

      axios({
          method: "get",
          url: request_url,
          params: {
            instance: this.$config.query_params.env
          }
      })
      .then((response) => {
          this.main_interaction_list_data = [];
          for (let item in response.data.items) {
              response.data.items[item].is_deleted = response.data.items[item].is_deleted ? 'В архіві' : 'Активний(-на)';
              this.main_interaction_list_data.push(response.data.items[item]);
          }

          this.main_interaction_list_size = response.data.count;
      })
      .catch((error) => {})
      .finally(() => {
          this.main_interaction_list_loading = false;
      });
    },

    requestServerList() {
      this.main_server_list_loading = true;
      const query_params = new URLSearchParams(clib.getFiltersQuery(this.$config, 'server')).toString();

      let request_url = "";
      if (this.current_server_page && this.main_server_list_items_per_page)
        request_url = this.$config.configuration.server.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + "?page=" + this.current_server_page + "&page_size=" + this.main_server_list_items_per_page + "&" + query_params;
      else
        request_url = this.$config.configuration.server.list.endpoints.list.replace(':backend_url', this.$config.backend_url) + query_params;

      for (let search_item in this.main_server_list_search_fields) {
        if (this.main_server_list_search_fields[search_item]) {
          request_url += "&search_" + search_item + "=" + this.main_server_list_search_fields[search_item];
        }
      }

      this.axiosSecure({
          method: "get",
          url: request_url,
          params: {
            instance: this.$config.query_params.env
          }
      })
      .then((response) => {
          this.main_server_list_data = [];
          for (let item in response.data.items) {
              response.data.items[item].is_deleted = response.data.items[item].is_deleted ? 'В архіві' : 'Активний(-на)';
              response.data.items[item].annotated_last_central_request_at = this.$clib.time_difference_ukrainian(response.data.items[item].annotated_last_central_request_at);

              this.main_server_list_data.push(response.data.items[item]);
          }

          console.log(this.main_server_list_data);

          this.main_server_list_size = response.data.count;
      })
      .catch((error) => {})
      .finally(() => {
          this.main_server_list_loading = false;
      });
    },
  }
};
</script>
